import { registerPlugin } from "@capacitor/core";

import type { IapPlugin } from "./definitions.js";

export const Iap = registerPlugin<IapPlugin>("Iap", {
  web: () => import("./web.js").then((m) => new m.IapWeb()),
});

export type {
  GetProductsOptions,
  GetProductsResult,
  IapPlugin,
  Product,
  PurchaseOptions,
  PurchaseResult,
  RestoreResult,
} from "./definitions.js";
